import useKeyboardShortcut from '@hooks/useKeyboardShortcut.hook';

/**
 * The draw-mode hotkeys of annotation mode — D draw, V select, E erase, R rotate —
 * shared by the legacy draw tools and the object flow's tool picker so both
 * answer to the same keys. `startSelect` and `startErase` are optional: a flow
 * without that tool leaves the key unbound.
 *
 * @param {object} options
 * @param {boolean} options.enabled - false while the tools are disabled or annotation mode is off
 * @param {() => void} options.startDraw
 * @param {() => void} [options.startSelect]
 * @param {() => void} [options.startErase]
 * @param {() => void} options.toggleRotation
 */
export const useAnnotationDrawShortcuts = ({
	enabled,
	startDraw,
	startSelect,
	startErase,
	toggleRotation,
}) => {
	useKeyboardShortcut('D', enabled, () => startDraw());
	useKeyboardShortcut('V', enabled && Boolean(startSelect), () => startSelect?.());
	useKeyboardShortcut('E', enabled && Boolean(startErase), () => startErase?.());
	useKeyboardShortcut('R', enabled, () => toggleRotation());
};
